/** Google Analytics 4 for the owner's traffic view of the public classroom. */
const measurementId = "G-TEZCC8FQY1";
const measurementIds = new Map([
  ["la.us-ai.co.kr", measurementId],
  ["la-son.garamlabs.com", "G-KDWWP1LZXD"],
  ["la-lee.garamlabs.com", "G-C7Q4JXM5GS"],
]);

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Learner pages on the production hosts only: operator pages stay out of analytics, and local
 * builds and automated browsers (probes, Playwright) would otherwise count as visitors.
 */
export function analyticsAllowed(page: { hostname: string; pathname: string; webdriver: boolean }) {
  return (
    measurementIds.has(page.hostname) &&
    !page.webdriver &&
    page.pathname !== "/settings" &&
    page.pathname !== "/evaluation"
  );
}

export function measurementIdForHost(hostname: string) {
  return measurementIds.get(hostname);
}

/** The standard gtag.js snippet, loaded from code because the CSP allows no inline script. */
export function startAnalytics() {
  const { hostname, pathname } = window.location;
  if (!analyticsAllowed({ hostname, pathname, webdriver: navigator.webdriver })) return;
  const hostMeasurementId = measurementIdForHost(hostname);
  if (!hostMeasurementId) return;
  window.dataLayer ??= [];
  const dataLayer = window.dataLayer;
  window.gtag = function gtag() {
    // gtag.js reads each entry as an Arguments object, not an array.
    // biome-ignore lint/complexity/noArguments: required by the gtag.js command queue
    dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", hostMeasurementId);
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${hostMeasurementId}`;
  document.head.appendChild(script);
}
